import { useThree as v } from "@react-three/fiber";
import { memo as j, useMemo as R, useRef as V, useCallback as D, useEffect as F } from "react";
import { Raycaster as h, Vector2 as d, Plane as x } from "three";
import { useRefPersistent as y } from "../../hooks/index7.js";
import { ProjectScreenToPlanePoint as w } from "../../utils/index24.js";
import { Vectors as S } from "../../utils/index36.js";
import { jsx as L, Fragment as T } from "react/jsx-runtime";
const P = new h(), C = new d(), G = j(function({
  helper: k,
  constant: u,
  normal: a = S.Up,
  clickMoveTolerance: p = 5,
  ...b
}) {
  const s = R(() => new x(a, u), [a, u]), i = V(), E = y(b), f = v((n) => n.camera), e = v((n) => n.gl), g = D((n) => {
    const t = i.current;
    if (!t)
      return;
    i.current = void 0;
    const o = new d(t.clientX, t.clientY), c = new d(n.clientX, n.clientY);
    if (!(o.distanceToSquared(c) > p))
      return !0;
  }, [p]);
  return F(() => {
    function n(r) {
      if (!g(r))
        return;
      const m = w({
        event: r,
        pointer: C,
        camera: f,
        raycaster: P,
        plane: s,
        el: e.domElement
      }), {
        onClick: l
      } = E();
      l && l(m);
    }
    function t(r) {
      i.current = r;
    }
    function o() {
      i.current = void 0;
    }
    function c(r) {
      const {
        onDoubleClick: m
      } = E();
      if (!m)
        return;
      const l = w({
        event: r,
        pointer: C,
        camera: f,
        raycaster: P,
        plane: s,
        el: e.domElement
      });
      m(l);
    }
    return e.domElement.addEventListener("pointerdown", t), e.domElement.addEventListener("pointerup", n), e.domElement.addEventListener("pointercancel", o), e.domElement.addEventListener("pointerleave", o), e.domElement.addEventListener("dblclick", c), () => {
      e.domElement.removeEventListener("pointerdown", t), e.domElement.removeEventListener("pointerup", n), e.domElement.removeEventListener("pointercancel", o), e.domElement.removeEventListener("pointerleave", o), e.domElement.removeEventListener("dblclick", c);
    };
  }, []), /* @__PURE__ */ L(T, {
    children: k && /* @__PURE__ */ L("planeHelper", {
      args: [s]
    })
  });
});
export {
  G as PlaneFC
};
//# sourceMappingURL=index.js.map
